// src/pages/ForgotPassword/ForgotPassword.js
import React, { useState } from 'react'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Link
} from '@mui/material'
import { LockResetRounded, ArrowBackRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import api from '../../services/api'

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const onSubmit = async (data) => {
    setLoading(true)
    setError('')
    try {
      await api.post('/api/auth/password-reset/', { email: data.email })
    } catch (err) {
      // Mostra sucesso mesmo em erro para não revelar se o email existe
      console.error(err)
    } finally {
      setSent(true)
      setLoading(false)
    }
  }

  return (
    <Container component='main' maxWidth='xs'>
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Paper elevation={3} sx={{ p: 3, width: '100%', borderRadius: 2 }}>
          {/* Logo */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2
            }}
          >
            <Box
              component='img'
              src='/logo_aux.png'
              alt='Umarkt'
              sx={{ width: 50, height: 50 }}
            />
            <Typography component='h1' variant='h5' fontWeight='bold'>
              Umarkt
            </Typography>
          </Box>

          <Typography variant='h6' textAlign='center' fontWeight={600} sx={{ mb: 1 }}>
            Redefinir senha
          </Typography>

          {!sent ? (
            <>
              <Typography variant='body2' textAlign='center' color='text.secondary' sx={{ mb: 3 }}>
                Digite seu email cadastrado e enviaremos um link para redefinir sua senha.
              </Typography>

              {error && (
                <Alert severity='error' sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <Box component='form' onSubmit={handleSubmit(onSubmit)}>
                <TextField
                  margin='dense'
                  required
                  fullWidth
                  size='small'
                  label='Email'
                  type='email'
                  autoFocus
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  {...register('email', {
                    required: 'Email é obrigatório',
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: 'Email inválido'
                    }
                  })}
                />

                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  sx={{ mt: 2, mb: 2, py: 1 }}
                  disabled={loading}
                  startIcon={<LockResetRounded />}
                >
                  {loading ? 'Enviando...' : 'Enviar link de redefinição'}
                </Button>
              </Box>
            </>
          ) : (
            <Alert severity='success' sx={{ mb: 3 }}>
              <Typography variant='body2' fontWeight={600} gutterBottom>
                Email enviado!
              </Typography>
              <Typography variant='body2'>
                Se este email estiver cadastrado, você receberá um link para redefinir sua senha em breve. Verifique também a caixa de spam.
              </Typography>
            </Alert>
          )}

          <Box sx={{ textAlign: 'center' }}>
            <Link
              component={RouterLink}
              to='/login'
              variant='body2'
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                textDecoration: 'none',
                color: 'text.secondary',
                '&:hover': { color: 'primary.main' }
              }}
            >
              <ArrowBackRounded fontSize='small' />
              Voltar ao login
            </Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}

export default ForgotPassword
